import {G_REPORT_SOURCE_MAP, G_ERROR_CODE_MAP } from './../config/index'
import M_ENV from './components/env/index' // 环境模块
import M_TOOLKIT from './components/toolkit/index' // 工具类模块
import M_HOOK from './components/hook/index' // 绑定钩子模块
import M_WEEX_FRAMEWORK from './../weex/index'
import M_MONITOR_REPORT from './components/monitor/index'
import M_CONFIG_VERSION from './../config/version.js'

let M_FRAMEWORK = null
let M_FRAMEWORK_COLLECT = null
let M_FRAMEWORK_DATA = null
let M_FRAMEWORK_REPORT = null
let M_FRAMEWORK_STRATEGY = null
const G_VERSION = M_CONFIG_VERSION.version
// 先判断环境，引入不同的模块
// todo 加入打包逻辑，根据不同的场景打包不同的framework，无需引入所有framework模块
if (M_ENV.isWeex) {
    M_FRAMEWORK = M_WEEX_FRAMEWORK
    M_FRAMEWORK_COLLECT = M_FRAMEWORK.M_COLLECT
    M_FRAMEWORK_DATA = M_FRAMEWORK.M_DATA
    M_FRAMEWORK_REPORT = M_FRAMEWORK.M_REPORT
    M_FRAMEWORK_STRATEGY = M_FRAMEWORK.M_STRATEGY
}
// 由于一期没有h5单独的处理逻辑，先使用weex进行兼容
else {
    M_FRAMEWORK = M_WEEX_FRAMEWORK
    M_FRAMEWORK_COLLECT = M_FRAMEWORK.M_COLLECT
    M_FRAMEWORK_DATA = M_FRAMEWORK.M_DATA
    M_FRAMEWORK_REPORT = M_FRAMEWORK.M_REPORT
    M_FRAMEWORK_STRATEGY = M_FRAMEWORK.M_STRATEGY
}

class LXDataReport {
    /**
     * @description 初始化行为
     * @param {Object} params 初始化入参
     * @param {boolean} params.locationInfoSwitch H5是否开启地理位置监听上报，默认打开，如果有业务需求认为地理信息权限开关影响体验，可以选择关闭
     * @param {boolean} params.tracelessSwitch 是否开启无痕埋点
     * @param {boolean} params.mainSwitch 是否执行JS 关闭则所有上报关闭
     * @param {boolean} params.reportSwitch 是否开启上报
     * @param {boolean} params.isStrategy 是否请求策略系统
     * @param {String} params.pageId 策略的page_id isStrategy为true时才有用
     * 
     */
    constructor (params = {}) {
        /** --------------------------------------------- 公有变量开始 ---------------------------------------------*/
        // 初始化时间 进入页时间
        this.initTime = M_TOOLKIT.getTime()
        // 退出页面的时间
        this.pageExitTime = 0
        // 是否已上报pv，避免重复触发  
        this.isReportPv = !!params.isReportPv
        // 是否已上报停留时长
        this.isReportPageStay = false
        // 是否已经触发离开事件
        this.isReportLeave = false
        // js sdk 版本号
        this.jsSdkVersion = G_VERSION
        // 是否初始化完成 用来判断是否已经初始化完成，是否使用正常的上报逻辑，不再使用缓存
        this._isInit = false 
        // 初始化入参
        this.pageId = params.pageId || '' // page id
        // 函数调用缓存
        this._cache = {}
        /** --------------------------------------------- 业务可修改的变量 ---------------------------------------------*/
        // 是否开启策略 默认关闭 - 默认研发自动引入
        this.isStrategy = !!params.isStrategy
        
        // H5是否开启地理位置监听上报，默认关闭，如果有业务需求认为地理信息权限开关影响体验，可以选择开启
        this.locationInfoSwitch = false
        // // 是否开启批量上报功能，默认关闭
        // this.isH5BatchReport = !!params.isH5BatchReport
        // // 批量上报条数，默认10条
        // this.batchReportNum = params.batchReportNum ? params.batchReportNum : 10

        // 策略相关
        this.tracelessSwitch = !!params.tracelessSwitch // 默认关闭无痕开关
        this.mainSwitch = params.mainSwitch !== undefined ? params.mainSwitch : true // 默认开启总开关
        this.reportSwitch = params.reportSwitch !== undefined ? params.reportSwitch : true // 默认开启上报开关

        this.globalStrategy = {} // 全局策略内容
        /** ---------------------------------------------业务可修改的变量 ---------------------------------------------*/

        /** ---------------------------------------------绑定当前实例至全局 --------------------------------------------- */

        M_HOOK.hookToGlobal(this)

        /** ---------------------------------------------绑定当前实例至全局 --------------------------------------------- */
        // 初始化行为
        this._init('init', this, params)
    }

    // -------------------------------------------------- 私有方法 ------------------------------------------------------------
    /**
     * @method _init
     * @description 对象实例化化执行
     * @param {string} cmd 命令
     * @param {object} instance 当前实例对象
     * @param {object} params 实例化入参
     * @example LXDataReport._init({})
     */
    async _init (cmd, instance, params) {
        try {
            // 策略模块初始化
            if (instance.isStrategy) {
                await M_FRAMEWORK_STRATEGY.execute(cmd, instance, params)
            }
            let _this = this
            // 总开关关闭才执行真正初始化
            // 采集模块初始化行为 传入当前实例的参数
            if (instance.mainSwitch) {
                M_FRAMEWORK_COLLECT.execute(cmd, instance, params)

                _this._isInit = true // 初始化完成，扭转标识

                setTimeout(()=>{
                    _this._cacheExec.apply(_this)
                }, 10) // 移动至异步队列，不影响正常上报任务
            }
        } catch (e) {
            M_MONITOR_REPORT.errorReport({
                error_log_info: {
                    error_code: G_ERROR_CODE_MAP._init,
                    error_desc: e.toString()
                }
            })
        }
    }

    /**
     * @method _pageViewReport
     * @description pv上报方法 页面PV和UV统计口径为page_url有值、且event_pos为空且event_type=1；
     * @example LXDataReport._pageViewReport({})
     */
    _pageViewReport () {
        try {
            // 扭转标识
            this.isReportPv = true
            // pv数据特殊采集逻辑
            let collect_params = M_FRAMEWORK_COLLECT.execute('pv', this, {})

            // pv数据特殊数据处理逻辑
            collect_params = M_FRAMEWORK_DATA.execute('pv', this, collect_params)

            // 执行通用上报逻辑
            this._pageReport(collect_params)
        } catch (e) {
            M_MONITOR_REPORT.errorReport({
                error_log_info: {
                    error_code: G_ERROR_CODE_MAP._pageViewReport,
                    error_desc: e.toString()
                }
            })
        }
    }

    /**
     * @method _pageStayReport
     * @description 页面停留时长上报方法 
     * @example LXDataReport._pageStayReport({})
     */
    _pageStayReport () {
        try {
            // 扭转标识
            this.isReportPageStay = true
            // pageStay数据特殊采集逻辑
            let collect_params = M_FRAMEWORK_COLLECT.execute('pageStay', this, {
                report_source: G_REPORT_SOURCE_MAP['sdk']
            })

            // pageStay数据特殊数据处理逻辑
            collect_params = M_FRAMEWORK_DATA.execute('pageStay', this, collect_params)

            // 执行通用上报逻辑
            this._pageReport(collect_params)
        } catch (e) {
            M_MONITOR_REPORT.errorReport({
                error_log_info: {
                    error_code: G_ERROR_CODE_MAP._pageStayReport,
                    error_desc: e.toString()
                }
            })
        }
    }

    /**
     * @method _forceReporter
     * @description 离开页面上报触发 给予内部/外部调用，通知当前为离开页面，从缓存中取出全部上报内容，一次性上报 （仅app外生效，app内由app监听实现）
     * @param {object} params 
     * @param {Number} params.report_source 是否业务主动调用 1为sdk  2为业务
     * @example LXDataReport._forceReporter({})
     */
    _forceReporter (params) {
        M_FRAMEWORK_REPORT.execute('force', this, params)
    }

    /**
     * @method _leaveReporter
     * @description 离开页面上报行为 （仅app外生效，app内由app监听实现）
     * @param {object} params 
     * @param {Number} params.report_source 是否业务主动调用 1为sdk  2为业务
     * @example LXDataReport._leaveReporter({})
     */
    _leaveReporter () {
        try {
            // 扭转标识
            this.isReportLeave = true

            let params = M_FRAMEWORK_COLLECT.execute('leave', this, {
                report_source: G_REPORT_SOURCE_MAP['sdk']
            })

            params = M_FRAMEWORK_DATA.execute('leave', this, params)

            this._pageReport(params)
        } catch (e) {
            M_MONITOR_REPORT.errorReport({
                error_log_info: {
                    error_code: G_ERROR_CODE_MAP._leaveReporter,
                    error_desc: e.toString()
                }
            })
        }
    }

    /**
     * @method _domReportHandler
     * @description 节点上报处理方法 - 提供给内部/外部使用，传入dom节点，得到当前H5/WEEX节点中的可用信息，并且进行上报
     * @param {object} params dom节点信息 
     * @param {Number} params.report_source 是否业务主动调用 1为sdk  2为业务
     * @example LXDataReport.domReportHandler({})
     */
    _domReportHandler (params) {
        try {
            // 调用数据采集模块采集设备基础数据
            let handle_params = M_FRAMEWORK_COLLECT.execute('dom', this, params)

            // 调用数据处理模块进行数据标准化处理
            handle_params = M_FRAMEWORK_DATA.execute('dom', this, handle_params)

            // 执行通用上报逻辑
            this._pageReport(handle_params)
        } catch (e) {
            M_MONITOR_REPORT.errorReport({
                error_log_info: {
                    error_code: G_ERROR_CODE_MAP._domReportHandler,
                    error_desc: e.toString()
                }
            })
        }
    }

    /**
     * @method _pageReport
     * @description 页面行为上报行为 所有字段选传
     * ***************************************** 旧参数 *************************************************************
     * @param {object} params
     * @param {string} params.page_name - 页面title，业务如果不传入，尝试从页面title处获取，如果没有则为空
     * @param {string} params.event_pos - 行为事件发生位置标记值 规范:http://wiki.fenqile.com/pages/viewpage.action?pageId=36554058
     * @param {string} params.event_pos_name - 行为事件发生位置标记值语义化名称
     * @param {int} params.event_type - 行为事件类型 规范:http://wiki.fenqile.com/pages/viewpage.action?pageId=37488107
     * @param {string} params.isc - 站内广告渠道 
     * @param {string} params.osc - 站外广告渠道 业务可以手动传入或写入cookie，手动传入则认传入数据
     * @param {object} params.extend_info - 业务额外定制信息 直接透传不处理
     * ***************************************** 旧参数 *************************************************************
     * ***************************************** 新参数 *************************************************************
     * 新参数参考：https://doc.weixin.qq.com/sheet/e3_AJcA0Qa6APYUA50GQSMSgOM09kJDV?scode=AAYA0wfQAAwdD6cYE0ACMAvAa0APY&tab=xw9udh
     * @param {String} params.event_case_code 埋点code 由业务到行为事件管理系统注册后上报，全新上报必填
     * @param {Number} params.report_source 是否业务主动调用 1为sdk  2为业务
     * @param {String} params.event_params.event_code eg:page_view，业务兼容改造或全新上报必传。其他由SDK映射转换，映射关系见事件sheet页
     * @param {String} params.event_params.flx_page 页面Code
     * @param {String} params.event_params.flx_domain 域名Code
     * @param {String} params.event_params.flx_module 模块ID
     * @param {String} params.event_params.flx_element 元素Code
     * @param {String} params.event_params.fix_element_name 元素文案
     * @param {String} params.event_params.fix_element_type 元素类型
     * @param {String} params.event_params.param_content 参数值
     * @param {Object} params.business_params 业务公参
     * @param {Object} params.standard_extend_info 新版业务的拓展字段
     * 
     * ***************************************** 新参数 *************************************************************
     * @example LXDataReport.pageReport({}, () => {})
     */
    _pageReport (params) {
        try {
            // 调用数据采集模块采集设备基础数据
            let handle_params = M_FRAMEWORK_COLLECT.execute('base', this, params)

            // 调用数据处理模块进行数据标准化处理
            handle_params = M_FRAMEWORK_DATA.execute('base', this, handle_params)

            // 调用上报模块进行数据上报
            M_FRAMEWORK_REPORT.execute('base', this, handle_params)
        } catch (e) {
            M_MONITOR_REPORT.errorReport({
                error_log_info: {
                    error_code: G_ERROR_CODE_MAP._pageReport,
                    error_desc: e.toString()
                }
            })
        }
    }

    /**
     * @method _cacheCollect
     * @description 缓存采集 在初始化完成前缓存所有公有方法操作
     * @param {String} funcName 方法名
     * @param {Object} params 调用参数 
     */
    _cacheCollect (funcName, params) {
        try {
            // 是否之前已经建立缓存 没有则初始化
            this._cache[funcName] ? '' : this._cache[funcName] = []

            this._cache[funcName].push(params)
        } catch (e) {
            M_MONITOR_REPORT.errorReport({
                error_log_info: {
                    error_code: G_ERROR_CODE_MAP._cacheCollect,
                    error_desc: e.toString()
                }
            })
        }
    }

    /**
     * @method _cacheExec
     * @description 缓存执行 把初始后的缓存全部取出，并且逐个执行
     */
    _cacheExec () {
        try {
            let _this = this
        
            for (let i in _this._cache) {
                for (let j in _this._cache[i]){
                    let param = _this._cache[i][j]
                    // 执行对应逻辑
                    _this[i](param)
                }
            }

            _this._cache = []
        } catch (e) {
            M_MONITOR_REPORT.errorReport({
                error_log_info: {
                    error_code: G_ERROR_CODE_MAP._cacheCollect,
                    error_desc: e.toString()
                }
            })
        }
    }
    // -------------------------------------------------- 私有方法 ------------------------------------------------------------

    // -------------------------------------------------- 公用方法 ------------------------------------------------------------
    /**
     * @method domReportHandler
     * @description 节点上报处理方法 - 提供给内部/外部使用，传入dom节点，得到当前H5/WEEX节点中的可用信息，并且进行上报
     * @param {object} params dom节点信息 
     * @example LXDataReport.domReportHandler({})
     */
    domReportHandler (params) {
        if (this._isInit) {
            // 标识业务上报
            params['report_source'] = G_REPORT_SOURCE_MAP['business']
            this._domReportHandler(params)
        } else {
            this._cacheCollect(this.domReportHandler.name, params)
        }
    }
    
    /**
     * @method forceReporter
     * @description 离开页面上报触发 给予内部/外部调用，通知当前为离开页面，从缓存中取出全部上报内容，一次性上报 （仅app外生效，app内由app监听实现）
     * @example LXDataReport.leavePageReporter({})
     */
    forceReporter () {
        // 标识业务上报
        this._forceReporter({
            report_source: G_REPORT_SOURCE_MAP['business']
        })
    }
    
    /**
     * @method _pageReport
     * @description 页面行为上报行为 所有字段选传
     * ***************************************** 旧参数 *************************************************************
     * @param {object} params 
     * @param {string} params.page_name - 页面title，业务如果不传入，尝试从页面title处获取，如果没有则为空
     * @param {string} params.event_pos - 行为事件发生位置标记值 规范:http://wiki.fenqile.com/pages/viewpage.action?pageId=36554058
     * @param {string} params.event_pos_name - 行为事件发生位置标记值语义化名称
     * @param {int} params.event_type - 行为事件类型 规范:http://wiki.fenqile.com/pages/viewpage.action?pageId=37488107
     * @param {string} params.isc - 站内广告渠道 
     * @param {string} params.osc - 站外广告渠道 业务可以手动传入或写入cookie，手动传入则认传入数据
     * @param {object} params.extend_info - 业务额外定制信息 直接透传不处理
     * ***************************************** 旧参数 *************************************************************
     * ***************************************** 新参数 *************************************************************
     * 新参数参考：https://doc.weixin.qq.com/sheet/e3_AJcA0Qa6APYUA50GQSMSgOM09kJDV?scode=AAYA0wfQAAwdD6cYE0ACMAvAa0APY&tab=xw9udh
     * @param {String} params.event_case_code 埋点code 由业务到行为事件管理系统注册后上报，全新上报必填
     * @param {Number} params.report_source 是否业务主动调用 1为sdk  2为业务
     * @param {String} params.event_params.event_code eg:page_view，业务兼容改造或全新上报必传。其他由SDK映射转换，映射关系见事件sheet页
     * @param {String} params.event_params.flx_page 页面Code
     * @param {String} params.event_params.flx_domain 域名Code
     * @param {String} params.event_params.flx_module 模块ID
     * @param {String} params.event_params.flx_element 元素Code
     * @param {String} params.event_params.fix_element_name 元素文案
     * @param {String} params.event_params.fix_element_type 元素类型
     * @param {String} params.event_params.param_content 参数值
     * @param {Object} params.business_params 业务公参
     * @param {Object} params.standard_extend_info 新版业务的拓展字段
     * 
     * ***************************************** 新参数 *************************************************************
     * @example LXDataReport.pageReport({})
     */
    pageReport (params) {
        if (this._isInit) {
            // 标识业务上报
            params['report_source'] = G_REPORT_SOURCE_MAP['business']
            this._pageReport(params)
        } else {
            this._cacheCollect(this.pageReport.name, params)
        }
    }

    /**
     * @method updateBusiness
     * @description 更新业务公参
     * @param {object} params 
     * @param {object} params.business_params - 业务公参 业务可以按需以对象形式传入
     * @param {string} params.url - 当前页面url 选填，APP内的H5，有概率缓存出错，传入此字段能保障缓存正确性
     * 
     * @example LXDataReport.updateBusiness({
     *      business_params:{
     *          orderId:xxxxx
     *      },
     *      url:xxxxx
     * })
     */
    updateBusiness (params) {
        if (this._isInit) {
            M_FRAMEWORK_COLLECT.execute('updateBusiness', this, params)
        } else {
            this._cacheCollect(this.updateBusiness.name, params)
        }
    }

    /**
     * @method updateInitParams
     * @description 更新开关
     * @param {object} params
     * @param {boolean} params.locationInfoSwitch H5是否开启地理位置监听上报，默认打开，如果有业务需求认为地理信息权限开关影响体验，可以选择关闭
     * @param {boolean} params.tracelessSwitch 是否开启无痕埋点
     * @param {boolean} params.mainSwitch 是否执行JS 关闭则所有上报关闭
     * @param {boolean} params.reportSwitch 是否开启上报
     * 
     * @example LXDataReport.updateInitParams({
     *      locationInfoSwitch:true,
     *      transId:xxxxx
     */
    updateInitParams (params) {
        // !params.autoDomReport ? this.autoDomReport = params.autoDomReport : ''
        params && params.locationInfoSwitch != undefined ? this.locationInfoSwitch = params.locationInfoSwitch : ''
        params && params.tracelessSwitch != undefined ? this.tracelessSwitch = params.tracelessSwitch : ''
        params && params.mainSwitch != undefined ? this.mainSwitch = params.mainSwitch : ''
        params && params.reportSwitch != undefined ? this.reportSwitch = params.reportSwitch : ''
    }

    // -------------------------------------------------- 私有方法 ------------------------------------------------------------
}

export default function (params) {
    let lx_report_instance = null

    // 不判断是否已存在LXDataReport，直接覆盖全局对象，以后调用的为主
    lx_report_instance = new LXDataReport(params)

    // 业务主动引入的情况，尽可能使用返回的实例进行后续调用
    return lx_report_instance
}
